module.exports = __webpack_public_path__ + "img/mgtv.09171726.png";